import { CommentCallbackArgs, CommentConfig } from "component/comment";
import { Feature } from "util/stdtypes";


export type ReplyNotifsConfig = {
    replyNotifsDisabled?: boolean;
}
export const ReplyNotificationsFeature : Feature<CommentConfig,ReplyNotifsConfig> = {
    name: 'Reply Notifications',
    key: 'replynotifications',
    dev: true,
    providesConfig: {
        commentPostTriggers: [postTriggerAsync],
    },
    receivesConfigDefaults:{
        replyNotifsDisabled: false
    }
}

export async function postTriggerAsync(args : CommentCallbackArgs) {
    const config = args.datastore.getConfig<ReplyNotifsConfig>()

    const {replyTo} = args.comment;
    if (!replyTo || config.replyNotifsDisabled ) return;
    await args.datastore.callServerAsync('notifs', 'sendNotifsForReply', {
        replyKey: args.commentKey, parentKey: replyTo
    });
}
